import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.PasskeyAuthButton', {
    title: 'Passkey',
    errorText: 'Failed to authenticate with passkey.',
});
